import { useQuery } from '@tanstack/react-query';
import { getSimulationReportCSV } from 'Services';
import { RQ_SINGLE_REPORT_CSV } from 'Utils';
import { useTranslation } from 'react-i18next';
import useReplaceMerchant from 'Hooks/useReplaceMerchant';
import useReportCsvErrorHandler from './useReportCsvErrorHandler';

function useSingleReportCSV(reportId: number, fileName: string) {
    const { t } = useTranslation();
    const errorHandler = useReportCsvErrorHandler({
        preContentMessage: t('Failed to export CSV'),
        title: t('Unable to export CSV')
    });

    const fixedFileName = useReplaceMerchant(fileName);

    return useQuery([RQ_SINGLE_REPORT_CSV, reportId], () => getSimulationReportCSV(reportId!), {
        enabled: false,
        onSuccess: (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = `${fixedFileName}.csv`;
            document.body.appendChild(link);
            link.click();
        },
        onError: errorHandler
    });
}

export default useSingleReportCSV;
